// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ox-2";
export var chatLink = "_ox-0";
export var chatText = "_ox-1";